/**
 * Database Screen Permissions
 * This module handles fetching and caching database-driven screen permissions
 */

import axiosInstance from 'helpers/api';

interface ScreenAccessMap {
  [moduleKey: string]: 'full' | 'read' | 'none';
}

let cachedScreenAccess: ScreenAccessMap | null = null;

/**
 * Fetch current user's screen permissions from database
 */
export const fetchScreenPermissions = async (): Promise<ScreenAccessMap> => {
  try {
    const response = await axiosInstance.get('/admin/my-screen-access');
    if (response.data?.success && response.data?.screenAccess) {
      cachedScreenAccess = response.data.screenAccess;
      console.log('📋 [Permissions] Loaded database screen permissions:', cachedScreenAccess);
      return cachedScreenAccess;
    }
    return {};
  } catch (error) {
    console.error('❌ [Permissions] Failed to fetch screen permissions:', error);
    return {};
  }
};

/**
 * Get cached screen permissions
 */
export const getCachedScreenPermissions = (): ScreenAccessMap => {
  return cachedScreenAccess || {};
};

/**
 * Check if user has access to a specific screen based on database permissions
 */
export const hasScreenAccess = (moduleKey: string): boolean => {
  const permissions = getCachedScreenPermissions();
  const accessLevel = permissions[moduleKey];
  return accessLevel === 'full' || accessLevel === 'read';
};

/**
 * Clear cached permissions (useful on logout)
 */
export const clearCachedPermissions = () => {
  cachedScreenAccess = null;
};

/**
 * Initialize permissions on app startup or login
 */
export const initializePermissions = async () => {
  await fetchScreenPermissions();
};